const style = (theme) => {
  const output = {
    menuWrapper: {
      position: 'relative',
    },
    follow: {
      position: 'absolute',
      overflow: 'hidden',
      zIndex: 0,
      width: '20vw',
      height: '20vw',
      opacity: 0,
      top: 0,
      right: 0,
      marginRight: '50vw',
      marginTop: '-10vw',
      pointerEvents: 'none',
      '& img': {
        position: 'absolute',
        zIndex: 1,
        top: 0,
        left: 0,
        objectFit: 'contain',
        fontFamily: "'object-fit: contain;'",
        opacity: 0,
        height: '100%',
        width: '100%',
        willChange: 'opacity',
      },
    },
    titleWrapper: {
      overflow: 'hidden',
    },
    navItemWrapper: {
      '& a': {
        position: 'relative',
        zIndex: 1,
        fontSize: 'calc(15px + 2vw)',
        fontFamily: theme.fonts[1],
        fontWeight: 700,
        lineHeight: 1.1,
        textTransform: 'uppercase',
        display: 'block',
        padding: '40px 0',
        '& span': {
          opacity: 0,
          display: 'block',
          transform: 'translateY(100%)',
          position: 'relative',
          '-webkit-text-fill-color': 'transparent',
          '-webkit-text-stroke-width': '1px',
          '-webkit-text-stroke-color': theme.getRgba(theme.colors[0], 0.45),

          '&:after': {
            pointerEvents: 'none',
            color: theme.colors[0],
            '-webkit-text-fill-color': theme.colors[0],
            '-webkit-text-stroke': 'unset',
            position: 'absolute',
            left: 0,
            display: 'inline-block',
            overflow: 'hidden',
            width: 'calc(100% + 10px)',
            fallbacks: {
              width: '120%',
            },
            whiteSpace: 'pre',
            content: 'attr(data-text)',
            transition: 'width 1s cubic-bezier(0.86, 0, 0.07, 1) -0.25s',
            willChange: 'width',
          },
        },
        '&:hover': {
          '& span': {
            '&:after': {
              width: '0%',
            },
          },
        },
      },
      '& .SimpleSplitText__firstText': {
        '-webkit-text-fill-color': theme.colors[0],
        '-webkit-text-stroke': 'unset',
      },
      '& .SimpleSplitText__secondText': {
        '-webkit-text-fill-color': 'transparent',
        '-webkit-text-stroke-width': '1px',
        '-webkit-text-stroke-color': theme.getRgba(theme.colors[0], 0.45),
      },
    },
    line: {
      height: 1,
      width: '100%',
      display: 'block',
      willChange: 'transform',
      backfaceVisibility: 'hidden',
      background: theme.colors[0],
    },
  }

  output[theme.mediaInverse.sm] = {
    navItemWrapper: {
      '& a': {
        fontSize: 'calc(10px + 2vw)',
      },
    },
  }

  return output
}

export default style
